import React from 'react';
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from '@react-navigation/native-stack';
import {useTheme} from 'contexts/ThemeContext';
import {Flows, ScreenName, Screens} from './Screens';
import HeaderBackButton from 'components/atoms/headerBackButton';
import strings from '../translations';
import styleSheet from './styles';
import {RouteProp} from '@react-navigation/native';
import {Platform} from 'react-native';

const Stack = createNativeStackNavigator();

export interface EditProfileProps {
  image?: string;
  name: string;
}

export interface ProfileScreenProps {
  navigation: NativeStackNavigationProp<{
    [ScreenName.terms]: undefined;
    [ScreenName.editProfile]: EditProfileProps;
    [ScreenName.privacy]: undefined;
    [Flows.authFlow]: undefined;
  }>;
}

export interface EditProfileScreenProps {
  navigation: NativeStackNavigationProp<{}>;
  route: any;
}

const ProfileFlow = () => {
  const theme = useTheme();
  const styles = styleSheet(useTheme());

  return (
    <Stack.Navigator
      screenOptions={({navigation, route}) => ({
        headerLeft: () => <HeaderBackButton onPress={() => navigation.pop()} />,
        headerStyle: styles.headerStyle,
        headerTitleStyle: styles.headerTitleStyle,
        headerTitleAlign: 'center',
        headerShadowVisible: false,
      })}>
      <Stack.Screen
        name={Screens.ProfileScreen.name}
        component={Screens.ProfileScreen.screen}
        options={{headerShown: false}}
      />
      <Stack.Screen
        name={Screens.PrivacyPolicyScreen.name}
        component={Screens.PrivacyPolicyScreen.screen}
        options={{headerShown: false}}
      />
      <Stack.Screen
        name={Screens.TermsAndCondsScreen.name}
        component={Screens.TermsAndCondsScreen.screen}
        options={{headerShown: false}}
      />
      <Stack.Screen
        name={Screens.EditProfileScreen.name}
        component={Screens.EditProfileScreen.screen}
        options={{
          title: Screens.EditProfileScreen.name,
          headerShown: Platform.OS !== 'web',
        }}
      />
    </Stack.Navigator>
  );
};

export default ProfileFlow;
